import store from "@/store";

export const getFullBearerToken = () => {
  return store.state.authentication.token || "";
};

export const getBearerToken = () => {
  const fullToken = getFullBearerToken();

  if (!fullToken) return "";

  return fullToken.split("Bearer ")[1];
};

export const AUTH_TOKEN_LOCAL_STORAGE_KEY = "apollo-token";
